type TLogData = any;

const logs: Array<TLogData> = [];

export function ribbonLog(data: TLogData) {
	logs.push(data);

	if (location.href.indexOf("mapy.c") === -1) {
		/* eslint-disable-next-line */
		console.log(data);
	}
}

export function getRibbonLogs() {
	return logs;
}
